import React, { type FC, type ImgHTMLAttributes } from "react";

interface IImageProps {
  src?: string;
  src2x?: string;
  src3x?: string;
  radius?: number | string;
}

const StaticImageComponent: FC<
  IImageProps & ImgHTMLAttributes<HTMLImageElement>
> = ({
  alt,
  width,
  height,
  radius,
  className,
  style,
  srcSet,
  src,
  src2x,
  src3x,
  ...otherProps
}) => {
  return (
    <img
      {...otherProps}
      className={className}
      data-src={src2x ? `${src} 1x, ${src2x} 2x, ${src3x} 3x` : src}
      srcSet={src2x ? `${src} 1x, ${src2x} 2x, ${src3x} 3x` : src}
      draggable={false}
      style={
        {
          ...style,
          borderRadius: radius,
          WebkitUserDrag: "none",
        } as React.CSSProperties
      }
      src={src}
      alt={alt}
      width={width}
      height={height}
    />
  );
};

export const StaticImage = React.memo(StaticImageComponent);
